<template>
	<div class="salesWrapper">
		<!-- <NavBar /> -->
		<div class="cartContainer"><Cart /></div>
	</div>
</template>

<script>
// import NavBar from "@/components/NavBar.vue";
import Cart from '@/components/Cart.vue'

export default {
	name: 'Sales',
	components: {
		// NavBar,
		Cart
	}
}
</script>

<style scoped>
@import '../styles/Cart.css';
</style>
